<template>
    <div>

        <div class="container-new right-info-block" style="text-align: center;">
            <div class="order-instruction-header mb-20">
                <i class="ion-information-circled header-icon"></i>
                <h2>{{headings[step]}}</h2>
            </div>
            <!-- step 1 -->
            <div class="simple-paragraph" v-show="step == 1">
                <p>Niniejszy formularz rejestracyjny pozwoli Ci na zamówienie kompleksowej usługi transportowej, a także dokonanie płatności online w wygodny dla Ciebie sposób.</p>
                <p>Postępuj zgodnie z instrukcjami dostępnymi w niniejszej części formularza. W razie napotkania jakichkolwiek problemów nasi konsultanci są do Twojej dyspozycji pod nr tel.: <span class="color-blue">(22) 307 68 98</span>.</p>
            </div>

            <div class="single-info" v-show="step == 1">
                <h3>1</h3>
                <p class="mb-20">Wybierz salon podjęcia z dostępnej listy, następnie przejdź dalej uprzednio sprawdzając poprawność dokonanego wyboru na mapie dostępniej poniżej.</p>
            </div>

            <!-- step 2 -->
            <div class="single-info" v-show="step == 2">
                <h3>1</h3>
                <p>Wprowadź adres realizacji usługi, który jest krokiem niezbędnym w wyliczeniu trasy przejazdu, a także kosztów transportu.</p>
            </div>
            <div class="single-info" v-show="step == 2">
                <h3>2</h3>
                <p class="mb-20">Przed przejściem dalej sprawdź poprawność wprowadzonych danych.</p>
            </div>

            <!-- step 3 -->
            <div class="single-info" v-show="step == 3">
                <h3>1</h3>
                <p>Wpisz numer zamówienia i jego wartość, następnie wciśnij przycisk "Dalej".</p>
            </div>
            <div class="single-info" v-show="step == 3">
                <h3>2</h3>
                <p class="mb-20">W przypadku większej ilości zamówień dodaj kolejne zamówienie wciskając przycisk <i class="ion-android-add-circle color-blue"></i> i postępuj zgodnie z pkt.1. Aby usunąć niechciane zamówienie wciśnij przycisk <i class="ion-android-cancel color-gray"></i>.</p>
            </div>

            <div class="single-info" v-show="step == 4">
                <h3>1</h3>
                <p>Wybierz preferowaną datę realizacji spośród dostępnych terminów.</p>
                <p>W przypadku wyboru innego terminu realizacji, wybierz opcję "Inny termin", a następnie wybierz preferowany termin realizacji z dostępnej listy.</p>
            </div>
            <div class="single-info" v-show="step == 4">
                <h3>2</h3>
                <p class="mb-20">Wybierz preferowany przedział godzinowy dostawy.</p>
            </div>


            <!-- step 5 -->
            <div class="single-info" v-show="step == 5">
                <h3>1</h3>
                <p>Prosimy o sprawdzenie w podsumowaniu poprawności uzupełnionych danych, a następnie wprowadzenie danych osobowych wraz z numerem telefonu i adresem mailowym na który wysłane zostanie potwierdzenie złożenia zamówienia, a także przyszłe powiadomienia o statusie zlecenia.</p>
            </div>

            <div class="single-info" v-show="step == 5">
                <h3>2</h3>
                <p>Jeżeli chcesz zmienić dane do faktury VAT, skorzystaj z opcji "Zmień dane do faktury".</p>
            </div>

            <div class="single-info" v-show="step == 5">
                <h3>3</h3>
                <p class="mb-20">Aby dokonać zamówienia usługi transportowej skorzystaj z opcji "Zamawiam". W przypadku, gdy Twoje zamówienie zostało już opłacone online lub stacjonarnie w salonie meblowym Agata, skorzystaj z opcji "Zamawiam (zapłacone)". Jeśli nie opłaciłeś jeszcze swojego zamówienia, wybierz opcję "Zamawiam (płacę)" w celu przejścia do wyboru płatności online.</p>
            </div>

        </div>

    </div>
</template>

<script>
    export default {
        name: 'rightBox',
        props: ["step"],
        data () {
            return {
                headings: [
                    '',
                    'Witaj w świecie dostaw DTS!',
                    'Wprowadzanie adresu realizacji',
                    'Dodawanie zamówień',
                    'Wybór terminu realizacji',
                    'Wprowadzanie danych odbiorcy'
                ]
            }
        },

        mounted: function() {

        },

        methods: {

        }
    }
</script>



// WEBPACK FOOTER //
// RightBox.vue?10979c87